import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import { Box } from '@mui/material'
import XSmallLogin from './features/login/XSmallLogin'
import SmallLogin from './features/login/SmallLogin'
import MediumLogin from './features/login/MediumLogin'
import LoginFooter from './features/login/LoginFooter'

function App() {
  const emailInputRef = useRef<any>(null)
  const [pageLoaded, setPageLoaded] = useState(false)
  const [userEmail, setUserEmail] = useState('')
  useEffect(() => { emailInputRef?.current?.focus() }, [])
  useEffect(() => { setTimeout(() => setPageLoaded(true), 300) }, [pageLoaded])
  useEffect(() => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const email = urlParams?.get("email")
    if (email) {
      setUserEmail(email)
    } else {
      setUserEmail('')
    }
  }, [])

  return (<>
    <Box sx={{
      height: 0,
      opacity: 0,
      transition: 'height 0ms 400ms, opacity 400ms 0ms',
      ...(pageLoaded && {
        height: 'auto',
        opacity: 1,
        transition: 'height 0ms 0ms, opacity 2500ms 0ms'
      })
    }}>
      <MediumLogin userEmail={userEmail} />
      <SmallLogin userEmail={userEmail} />
      <XSmallLogin userEmail={userEmail} />
      <LoginFooter />
    </Box>
  </>
  )
}

export default App
